import { render, staticRenderFns } from "./IconStatsDetails.vue?vue&type=template&id=9b38192e&"
import script from "./IconStatsDetails.vue?vue&type=script&lang=js&"
export * from "./IconStatsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9b38192e')) {
      api.createRecord('9b38192e', component.options)
    } else {
      api.reload('9b38192e', component.options)
    }
    module.hot.accept("./IconStatsDetails.vue?vue&type=template&id=9b38192e&", function () {
      api.rerender('9b38192e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconStatsDetails.vue"
export default component.exports